import { memo } from "react";
import { generatePath, Navigate } from "react-router";

import { PATHS } from "@/routes/paths";

import * as Repository from "@/components/features/design/plain/model/repository";

import { DesignPlainPresenter } from "./presenter";

type Props = {
	hotelID: string;
};

export const DesignPlainContainer = memo(({ hotelID }: Props) => {
	const { plainSettingForDesignPlain: plainSettingForDesignPlainServerModel } =
		Repository.Query.usePlainSettingQuery(hotelID);
	/** 最初の登録が完了しているかどうか */
	const isFirstRegistrationCompleted = Boolean(plainSettingForDesignPlainServerModel?.plainSetting.domainName);

	const { data: snackListServerModel } = Repository.Query.useSnackListQuery(hotelID);
	const { data: plainWidgetDefaultOfServerModel } = Repository.Query.usePlainWidgetQuery(hotelID);

	if (!plainSettingForDesignPlainServerModel || !snackListServerModel || !plainWidgetDefaultOfServerModel) {
		return <Navigate to={generatePath(PATHS.HOTEL.TOP, { hotelID })} />;
	}

	return (
		<DesignPlainPresenter
			hotelID={hotelID}
			plainSettingForDesignPlainServerModel={plainSettingForDesignPlainServerModel}
			snackListServerModel={snackListServerModel}
			plainWidgetDefaultOfServerModel={plainWidgetDefaultOfServerModel}
			isFirstRegistrationCompleted={isFirstRegistrationCompleted}
		/>
	);
});
